import { insertCommasIntoNumber } from '@trukt/utils/insertCommasIntoNumber';
import { Typography } from '../../Typography';
import { SidebarCountProps } from './SidebarCount.types';

export const SidebarCount = ({ count = 0, classNameCount }: SidebarCountProps) => {
  return (
    <div
      className={[
        'flex h-6 items-center justify-center rounded-md p-2',
        '[&_label]:text-common-white',
        classNameCount,
      ].join(' ')}
    >
      <Typography color="red">{insertCommasIntoNumber(count)}</Typography>
    </div>
  );
};
